import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";

/*
 * 24-HOUR AUTO-REFRESH HACK
 * * Why use a 5-minute polling interval instead of a flat 24-hour setInterval?
 * Modern browsers aggressively throttle or completely pause JavaScript execution
 * on inactive tabs to save battery and RAM.
 * * If we set a 24-hour timer and the tab goes to sleep, the timer pauses. A user
 * returning 26 hours later would still be waiting on the paused timer to finish.
 * * By checking the absolute system time (Date.now()) every 5 minutes, we outsmart
 * the browser's sleep mode. Even if the tab sleeps for 18 hours, the moment the
 * user brings it back to the foreground, the interval fires, realizes 24 real-world
 * hours have elapsed, and triggers the refresh instantly.
 */

function App() {
  useEffect(() => {
    const loadTime = Date.now();
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

    // Check the clock every 5 minutes (300,000 ms)
    const intervalId = setInterval(
      () => {
        if (Date.now() - loadTime >= TWENTY_FOUR_HOURS) {
          // TODO:
          // 1. navigate to dashboard
          // 2. to change the offer_shown to false
          // 3. make this a hard refresh or handle it using the versioning system

          // Passing true forces a reload from the server, bypassing the cache
          window.location.reload(true);
        }
      },
      5 * 60 * 1000,
    );

    return () => clearInterval(intervalId);
  }, []);

  // Prevent number input fields from changing values when scrolling or using arrow keys
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement?.type === "number") {
        e.preventDefault();
        document.activeElement?.blur();
      }
    };

    const handleKeyDown = (e) => {
      if (
        document.activeElement?.type === "number" &&
        (e.key === "ArrowUp" || e.key === "ArrowDown")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: false });
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("wheel", handleWheel);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return <AppRoutes />;
}

export default App;
